import React, { Dispatch, SetStateAction } from 'react'
import { useMeleeContext } from 'draft/context/MeleeContextProvider';

import { Modal, Image, Grid, Button, Popup } from 'semantic-ui-react'

import { Hero, TierConverter, IsSameTierGroup } from '../types'

import { getHeroImage, getHeroData } from 'draft/heroes/useHeroes';

// 'https://www.pgstats.com/articles/over-1-000-melee-community-members-rank-the-characters';

interface Props {
    open: boolean,
    setOpen: Dispatch<SetStateAction<boolean>>
}

const TierListModal = ({ open, setOpen }: Props) => {
    const meleeContext = useMeleeContext();
    if (!meleeContext) return <></>;

    const heroes = getHeroData(meleeContext.draftOptions.gameType);

    const getHeroesPartitions = (heroData: any) => {
        let tiersCount = 0;
        const heroList: Hero[] = [];
        for (var key in heroData) {
            var temp = heroData[key];
            heroList.push({
                Name: temp['Name'],
                Tier: temp['Tier'],
                Image: temp['Image']
            })
            if (temp['Tier'] > tiersCount) tiersCount = temp['Tier']
        }
        const heroesPartitions = [];
        for (let i = 0; i < tiersCount; i++) {
            const tierIndex = i + 1;
            const heroesInThisTier = heroList.filter((h) => h.Tier === tierIndex);
            heroesPartitions.push(heroesInThisTier);
        }
        return heroesPartitions
    }

    const tierSegments = () => {
        const heroPartitons = getHeroesPartitions(heroes);
        return (
            heroPartitons.map((partition, index) => {
                const currentTier = partition[0].Tier;
                let classNames = 'tier-row-' + currentTier + ' ';

                if (index + 1 < heroPartitons.length && !IsSameTierGroup(currentTier, heroPartitons[index + 1][0].Tier)) {
                    classNames += 'margin-bottom-small'
                }

                return (
                    <Grid className={classNames} key={`tier-${currentTier}-row`} >
                            <Grid.Column width={4} style={{margin:'auto'}}  >
                                <h3 className='tier-text'>Tier {TierConverter(currentTier)}</h3>
                            </Grid.Column>

                            <Grid.Column width={12}>
                                <div className='tier-heroes-column'>
                                    {partition.map((h) => {
                                        return (
                                            <Popup
                                                key={h.Name}
                                                header={h.Name}
                                                trigger={
                                                    <Image
                                                        src={getHeroImage(meleeContext.draftOptions.gameType, h)}
                                                    />
                                                }
                                            />
                                        )
                                    })
                                    }
                                </div>
                            </Grid.Column>
                    </Grid>
                )
            })
        )
    }

    return (
        <Modal
            onClose={() => setOpen(false)}
            onOpen={() => setOpen(true)}
            open={open}
            className='melee-modal'
        >
            <Modal.Content>
                <div style={{ marginBottom: 32, textShadow: "2px 2px 3px black" }}>
                    <h2>Tier List</h2>
                </div>
                {tierSegments()}

                <div className='action' style={{ marginTop: '3em' }}>
                    <Button
                        basic color='yellow' inverted onClick={() => setOpen(false)}>
                        Lukk
                    </Button>
                </div>

            </Modal.Content>
        </Modal>
    )
}

export default TierListModal;